import { IIdsRequest } from "../../model/request/IIdsRequest";
import { IPhongHoc } from "../../model/respone/category/IPhongHoc";
import { apiClient } from "../apiClient";

export const PHONG_HOC_API = "phong-hoc";
export const phongHocApi = {
  SelectAll: () => apiClient.get(`${PHONG_HOC_API}`),
  Insert: (payload: IPhongHoc) => apiClient.post(`${PHONG_HOC_API}`, payload),
  Update: (payload: IPhongHoc) => apiClient.put(`${PHONG_HOC_API}`, payload),
  Delete: (id: number) => apiClient.delete(`${PHONG_HOC_API}/${id}`),
  Deletes: (id: IIdsRequest) => apiClient.put(`${PHONG_HOC_API}/deletes`, id),
};
